import { createContext, useEffect, useState, useContext } from 'react';
import {
  onAuthStateChanged,
  signInWithPopup,
  GoogleAuthProvider,
  signOut,
} from 'firebase/auth';
import { auth } from '../firebase'; 
import { createUser,verifyUser } from '../services/UserService';


const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {

        verifyUser(user.uid).then(async (userData) => {

          if (userData) {
            
            const userWithPermissions = {
              ...user,
              permissions: userData.permissions || [],
              role: userData.role,
              firstLogin: userData.firstLogin
            };
            setCurrentUser (userWithPermissions);
          } else {
            
            const userWithPermissions = {
              ...user,
              firstLogin: true, 
              permissions: user.permissions || [],
              role: 'master',
              createdAt: new Date().toISOString()
            };
            
            setCurrentUser (userWithPermissions);
          }
        }).catch((error) => console.error("Erro ao verificar usuário:", error));
      }
    });
    return unsubscribe;
  }, []);

  const loginWithGoogle = () => {
    const provider = new GoogleAuthProvider();
    return signInWithPopup(auth, provider);
  };

  const logout = () => {
    setCurrentUser(null);
    return signOut(auth);
  };

  const updateUser = (userData) => {
    if (!currentUser) return;
    const updatedUser = { ...currentUser, ...userData };
    setCurrentUser(updatedUser);
    createUser(updatedUser); 
  };

  return (
    <AuthContext.Provider value={{ currentUser, loginWithGoogle, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
